import React, { useRef, useState } from "react";
import "./HomePage.css";
import ServicesSection from "./Service";
import { caseStudies } from "../../StaticData/caseStudiesData";
import { Container, Carousel } from "react-bootstrap";
import GetInTouchHome from "../../components/GetInTouch/GetInTouchHome";
import { Helmet } from "react-helmet";
import ServiceSlider from "./Test";
import VideoSlider from "../../components/HeroSection/VideoSlider";
import long_arrow from "../../assets/images/long_arrow.svg";
import InfoSection from "../../components/Banner/InfoSection";
import ISOCertificateModal from "../../components/modal/Isocertificatemodal.jsx"

const HomePage = (props) => {
  const [videoReady, setVideoReady] = useState(false);
  const [showISOModal, setShowISOModal] = useState(false);
  const videoRef = useRef(null);

  return (
    <div className="HomePage">
      <Helmet>
        <title>AI-Driven IT Services and Solutions | Idexcel</title>
        <meta
          name="description"
          content="We offering AI-driven IT solutions that optimize efficiency, automate processes, and enhance decision-making. Transform your business with cutting-edge AI technology. Get started today!"
        />
      </Helmet>

      <VideoSlider
        videoRef={videoRef}
        videoReady={videoReady}
        setVideoReady={setVideoReady}
      />

      <div className="aws-announcement-bar">
        <span style={{ marginTop: "5px" }}>
          Idexcel Achieves AWS Agentic AI Competency -{" "}
          <a
            href="/news/idexcel-achieves-aws-agentic-ai-competency"
            className="aws-read-more"
            style={{ textDecoration: "underline" }}
          >
            Read More
          </a>
        </span>
      </div>

      {videoReady && (
        <>
          <ServiceSlider />
          <ServicesSection />

          <section className="home-case" style={{ backgroundColor: "#F1F8FF" }}>
            <Container style={{ marginBottom: "20px" }}>
              <h1 className="text-center mb-4 section-title">
                Customer Success Stories
              </h1>
              <Carousel>
                {caseStudies.map((study) => (
                  <Carousel.Item key={study.id}>
                    <div
                      className="d-flex flex-column flex-xl-row flex-md-row align-items-center"
                      style={{ gap: "45px" }}
                    >
                      <div
                        className="carousel-image image-hover-zoom col-12 col-md-6"
                        style={{
                          flex: 1,
                          display: "flex",
                          justifyContent: "end",
                          borderRadius: "30px",
                          overflow: "hidden",
                        }}
                      >
                        <img
                          className="d-block"
                          src={study.image}
                          alt={study.title}
                          style={{
                            objectFit: "cover",
                            height: "100%",
                            width: "100%",
                          }}
                        />
                      </div>
                      <div className="carousel-text ml-3" style={{ flex: 1 }}>
                        <h3>{study.title}</h3>
                        <p>{study.description}</p>
                        <a
                          href={study.link}
                          target="_blank"
                          rel="noopener noreferrer"
                          className="arrow-container"
                        >
                          <img src={long_arrow} alt="Arrow" />
                        </a>
                      </div>
                    </div>
                  </Carousel.Item>
                ))}
              </Carousel>
            </Container>

            {/* <Container>
              <h1
                className="text-center mb-4 section-title"
                style={{ marginTop: "55px" }}
              >
                Security and Compliance
              </h1>

              <div className="security-container">
                <div className="security-images-wrapper">
                  <div
                    className="security-image-card security-image-card-1"
                    onClick={() => setShowISOModal(true)}
                    style={{ cursor: "pointer" }}
                    title="Click to download ISO Certificate"
                  >
                    <img src="/images/security1.png" alt="ISO Certificate" />
                  </div>
                </div>
              </div>
            </Container> */}
          </section>

          <GetInTouchHome />

          {/* ISO Certificate Form Modal */}
          <ISOCertificateModal
            showModal={showISOModal}
            handleClose={() => setShowISOModal(false)}
          />
        </>
      )}
    </div>
  );
};

export default HomePage;